import { render, staticRenderFns } from "./PdfStep.vue?vue&type=template&id=6adf60fc&scoped=true&"
import script from "./PdfStep.vue?vue&type=script&lang=js&"
export * from "./PdfStep.vue?vue&type=script&lang=js&"
import style0 from "./PdfStep.vue?vue&type=style&index=0&id=6adf60fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adf60fc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContactStepHeader: require('/opt/build/repo/components/contact/StepHeader.vue').default})
